/**
 * 提示词结构化辅助（P-D③b，对齐竞品"景别/视角/构图/镜头/光线/风格"标签）。
 * 纯数据：生成台在提示词框下方渲染这些分组，点标签弹可选词、点击追加到提示词。
 * 帮助创作者不写长句也能拼出专业分镜级描述。
 */
export interface PromptTermGroup {
  key: string;
  label: string;
  terms: string[];
}

export const PROMPT_ASSIST: PromptTermGroup[] = [
  { key: 'shot', label: '景别', terms: ['远景', '全景', '中景', '近景', '特写', '大特写'] },
  { key: 'angle', label: '视角', terms: ['平视', '俯拍', '仰拍', '鸟瞰', '过肩', '第一人称'] },
  { key: 'compose', label: '构图', terms: ['中心构图', '三分法', '对称构图', '引导线', '框架式', '大面积留白'] },
  { key: 'lens', label: '镜头类型', terms: ['广角', '长焦', '微距', '鱼眼', '移轴', '85mm 人像'] },
  { key: 'light', label: '光线', terms: ['自然光', '侧光', '逆光', '柔光', '硬光', '霓虹', '体积光', '伦勃朗光'] },
  { key: 'style', label: '风格', terms: ['电影感', '写实', '动漫', '油画', '赛博朋克', '水墨', '胶片颗粒'] },
];

/** 把选中的词追加到提示词（逗号分隔、去重）。纯函数可测。 */
export function appendTerm(prompt: string, term: string): string {
  const p = prompt.trim();
  if (p === '') {
    return term;
  }
  const parts = p.split(/[，,]/).map((s) => s.trim()).filter(Boolean);
  if (parts.includes(term)) {
    return p;
  }
  return `${p}，${term}`;
}
